const validateField = (field) => {
  const errors = {},
    valid = /[`¡!@#$%^&*()_+\-=\[\]{};´¨':"\\|,.<>\/¿?°~0123456789]/;

  if (field.value === "") {
    document.getElementById("submitButton").disabled = true;
    document.getElementById("submitButton").className =
      "btn btn-secondary mb-2";
    errors[field.name] = field.required || "Este campo es obligatorio.";
    document.getElementById("name").className = "form-control is-invalid";
  } else if (field.value.length < field.min) {
    errors[field.name] =
      field.maxValue ||
      "Falta de caracteres en este campo (Mínimo 5). Favor ingresar el nombre con mas caracteres.";
    document.getElementById("submitButton").disabled = true;
    document.getElementById("submitButton").className =
      "btn btn-secondary mb-2";
    document.getElementById("name").className = "form-control is-invalid";
  } else if (field.value.length > field.max) {
    errors[field.name] =
      field.shortValue ||
      "Se ha excedido el limite de carácteres en este campo (Máximo 100). Favor ingresar el nombre con menos caracteres.";
    document.getElementById("submitButton").disabled = true;
    document.getElementById("submitButton").className =
      "btn btn-secondary mb-2";
    document.getElementById("name").className = "form-control is-invalid";
  } else if (valid.test(field.value)) {
    errors[field.name] =
      field.validField || "Error, Favor ingresar solo caracteres alfabeticos.";
    document.getElementById("name").className = "form-control is-invalid";
    document.getElementById("submitButton").disabled = true;
    document.getElementById("submitButton").className =
      "btn btn-secondary mb-2";
  } else {
    document.getElementById("name").className = "form-control is-valid";

    if (
      document.getElementById("email").className === "form-control is-valid"
    ) {
      document.getElementById("submitButton").disabled = false;
      document.getElementById("submitButton").className =
        "btn btn-primary mb-2";
    }
  }

  return errors;
};

function validateEmail(email) {
  const errors = {},
    isValidEmail =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    valid = /[`¡!#$%^&*()_+\-=\[\]{};´¨':"\\|,<>\/¿?°~]/;
  if (email.value === "") {
    document.getElementById("submitButton").disabled = true;
    document.getElementById("submitButton").className =
      "btn btn-secondary mb-2";
    document.getElementById("email").className = "form-control is-invalid";
    errors.email = email.required || "Correo electrónico es requerido.";
  } else if (email.value.length > email.max) {
    errors.email =
      email.shortValue ||
      "Se ha excedido el limite de caracteres en este campo (50).";
    document.getElementById("submitButton").disabled = true;
    document.getElementById("submitButton").className =
      "btn btn-secondary mb-2";
    document.getElementById("email").className = "form-control is-invalid";
  } else if (!isValidEmail.test(email.value)) {
    errors.email = email.validEmail || "Correo electrónico no válido.";
    document.getElementById("email").className = "form-control is-invalid";
    document.getElementById("submitButton").disabled = true;
    document.getElementById("submitButton").className =
      "btn btn-secondary mb-2";
  } else if (
    email.value.split("@")[1] !== "uth.hn" &&
    email.value.split("@")[1] !== "mersa.hn" &&
    email.value.split("@")[1] !== "prestaya.hn" &&
    email.value.split("@")[1] !== "credirapid.hn" &&
    email.value.split("@")[1] !== "credimovil.hn" &&
    email.value.split("@")[1] !== "prestaauto.hn" &&
    email.value.split("@")[1] !== "compresa.hn" &&
    email.value.split("@")[1] !== "credibodega.hn" &&
    email.value.split("@")[1] !== "inversa.hn" &&
    email.value.split("@")[1] !== "cpn.hn"
  ) {
    errors.email = email.validDns || "Error, correo no autorizado";
    document.getElementById("email").className = "form-control is-invalid";
    document.getElementById("submitButton").disabled = true;
    document.getElementById("submitButton").className =
      "btn btn-secondary mb-2";
  } else if (valid.test(email.value)) {
    errors.email = email.validEmail || "Correo electrónico no válido.";
    document.getElementById("email").className = "form-control is-invalid";
    document.getElementById("submitButton").disabled = true;
    document.getElementById("submitButton").className =
      "btn btn-secondary mb-2 ";
  } else {
    document.getElementById("email").className = "form-control is-valid";

    if (document.getElementById("name").className === "form-control is-valid") {
      document.getElementById("submitButton").disabled = false;
      document.getElementById("submitButton").className =
        "btn btn-primary mb-2";
    }
  }
  return errors;
}

module.exports = { validateField, validateEmail };
